export const DEFAULT_STATE = {
  current: null,
  locations: [],
  selectionMade: false,
}

export default {
  ...DEFAULT_STATE
}
